export const convertPtoSpan = (htmlText) => {
  return htmlText.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>');
};
